module.exports = __webpack_public_path__ + "img/xinwen1.456dbd0c.png";